import React from 'react';
import { connect } from 'react-redux';
import WhatIfResultsExcelPres from '../presentational/WhatIfResultsExcelPres';
import { downloadExcel, setPageType } from '../state/whatIfActions';
import Typography from '@material-ui/core/Typography';

class WhatIfResultsExcelContainer extends React.Component {
  componentDidMount() {
    this.setState({
      headerTitle: this.getHeaderTitle(),
    });
  }

  getHeaderTitle() {
    const results = this.props.results;
    const hostCountries = Array.from(
      new Set(
        results.map(result => {
          return result.hostCountry;
        }),
      ),
    ).sort();

    let countriesString = '';
    if (hostCountries.length > 1) {
      countriesString = hostCountries.slice(0, hostCountries.length - 1).join(', ') + ' and ' + hostCountries[hostCountries.length - 1];
    } else {
      countriesString = hostCountries[0];
    }

    return (
      <Typography variant="title" style={{ fontFamily: "'EYInterstate Light', sans-serif" }}>
        You want to send your employees to <b>{countriesString}</b>
      </Typography>
    );
  }

  onClose = () => {
    this.props.setPageType('list');
  };

  onDownloadExcel = () => {
    const { results, downloadExcel } = this.props;

    const params = {
      calculations: results,
    };

    downloadExcel(params);
  };

  render() {
    return <WhatIfResultsExcelPres {...this.props} {...this.state} onClose={this.onClose} onDownloadExcel={this.onDownloadExcel} />;
  }
}

const mapStateToProps = state => ({
  results: state.whatIf.results,
  employees: state.whatIf.employees,
  isLoading: state.whatIf.isDownloadingExcel,
  lookups: state.whatIf.lookups,
});

const mapDispatchToProps = {
  setPageType,
  downloadExcel,
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatIfResultsExcelContainer);
